// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p.error[data-v-54d45874]{background-color:rgb(153 27 27/var(--tw-bg-opacity))}p.confirmation[data-v-54d45874],p.error[data-v-54d45874]{--tw-bg-opacity:1;--tw-text-opacity:1;color:rgb(255 255 255/var(--tw-text-opacity))}p.confirmation[data-v-54d45874]{background-color:rgb(22 101 52/var(--tw-bg-opacity))}", ""]);
// Exports
module.exports = exports;
